import React, { createContext, useContext } from 'react';

const EmailContext = createContext(null);

export const useEmailContext = () => useContext(EmailContext);

export const EmailProvider = ({ children, value }) => {
  return <EmailContext.Provider value={value}>{children}</EmailContext.Provider>;
};
